var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { compose, find, indexBy, mapObjIndexed, prop, propEq } from 'ramda';
import * as yup from 'yup';
import config from '../../config';
import { FeatureCode } from './features';
const settingSchema = yup.object().shape({
    code: yup.string().required(),
    type: yup.string().required(),
    value: yup.string().defined()
});
const featureSchema = yup.object({
    code: yup.string().required(),
    settings: yup.array().of(settingSchema.required())
});
const featureArraySchema = yup.array().min(1).of(featureSchema);
const coreParametersSchema = yup.object({
    HANDHELD_RING: yup.string(),
    HUB_RING: yup.string(),
    REGION_HUB: yup.string(),
    REGION_LANGUAGE: yup.string(),
    REGION_TEMPERATURE: yup.string(),
    REGION_TIMEZONE: yup.string()
});
const qrScanningSettingsSchema = yup.object({
    MULTIPLE_CHECKPOINT_TYPES: yup.string()
});
export function customerProfileClientFactory(getToken) {
    const axiosInstance = axios.create({
        baseURL: `${config.customerProfile.url}/api/`,
        responseType: 'json'
    });
    function getHeaders() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield getToken();
            return { Authorization: `Bearer ${token}` };
        });
    }
    const getFeature = (code) => find(propEq('code', code));
    const indexSettingsByCode = indexBy(prop('code'));
    const getValues = mapObjIndexed(prop('value'));
    const parseSettings = compose(getValues, indexSettingsByCode);
    function extractSettings(feature, schema) {
        if (!feature) {
            return null;
        }
        const unvalidated = parseSettings(feature.settings);
        return schema.validateSync(unvalidated);
    }
    function getFeatures() {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = yield getHeaders();
            const res = yield axiosInstance.get('features', { headers });
            const features = featureArraySchema.validateSync(res.data);
            const enabledFeatures = features.map((f) => f.code);
            const core = extractSettings(getFeature(FeatureCode.CORE)(features), coreParametersSchema);
            const qrScanning = extractSettings(getFeature(FeatureCode.QRSCANNING)(features), qrScanningSettingsSchema);
            return {
                enabledFeatures,
                settings: {
                    core,
                    qrScanning
                }
            };
        });
    }
    return {
        getFeatures
    };
}
//# sourceMappingURL=customerProfileClient.js.map